import { createSlice } from '@reduxjs/toolkit';
import { createGrn, getFabricLabels, getGrn, getQcData } from './api';

export const InventoryQcGrnSlice = createSlice({
    name: 'inventoryQcGrnSlice',
    initialState: {
        isLoading: false,
        data: {},
        // grnData: {},
        createGrnSuccessMessage: '',
        createGrnData: {},
        error: ''
    },

    reducers: {
      clear: (state, action) => {
        if(action?.payload?.key) {
          return {
            ...state,
            [action.payload.key]: action.payload.value
          }
        }
        return { ...state }
      },
      clearErrorState: (state, action) => {
        return {
          ...state,
          error: action.payload
        }
      }
    },

    extraReducers: (builder) => {
      builder.addCase(getQcData.pending, (state, action) => {
          state.isLoading = true;
          state.data = {};
      })
      builder.addCase(getQcData.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.data = action.payload.data;
      })
      builder.addCase(getQcData.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getGrn.pending, (state, action) => {
          state.isLoading = true;
          state.data = {};
      })
      builder.addCase(getGrn.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.data = action.payload.data;
      })
      builder.addCase(getGrn.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getFabricLabels.pending, (state, action) => {
        state.isLoading = true;
        // state.data = {};
      });
      builder.addCase(getFabricLabels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = "";
        // state.data = action.payload.data;
      });
      builder.addCase(getFabricLabels.rejected, (state, action) => {
        state.error = action.payload.message;
        state.isLoading = false;
      });
      builder.addCase(createGrn.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(createGrn.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.createGrnSuccessMessage = action.payload.data.message;
          state.createGrnData = {
            grn_id: action.payload.data.grn_id,
            gate_entry_id: action.payload.data.gate_entry_id,
            metadata: action.payload.data.metadata,
            state: action.payload.data.state,
            success_putaways: action.payload.data.success_putaways,
            reject_putaways: action.payload.data.reject_putaways,
          };
      })
      builder.addCase(createGrn.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      
      
    }
})

export const { clear } = InventoryQcGrnSlice.actions


export default InventoryQcGrnSlice.reducer